import {TFlatJsonStruct} from "@app/factory/flatJson";

export function foundSameValue (data: TFlatJsonStruct[], value:string)  {

    let mapOverData = data.filter(item => {
        if(item.translate === "" ) {
            return item.value === value
        }
    });

    return mapOverData
}